import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { ClickOutsideModule } from 'ng-click-outside';

import { ActivityComponentModule } from '../activity/activity.component.module';
import { YourCouponsComponent } from './your-coupons.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    ActivityComponentModule,
    ClickOutsideModule,
  ],
  declarations: [YourCouponsComponent],
  exports: [YourCouponsComponent],
  providers: [],
})
export class YourCouponsComponentModule {}
